import * as actions from "../global/actionTypes";
import decodePolyline from "../helpers/decodePolyline";

const initState = {
  data: {},
};

export default function (state = initState, action = {}) {
  switch (action.type) {
    case actions.FETCH_JOB_SUCCESS: {
      const { polylines } = action.response.data.output;
      const newData = {};
      Object.keys(polylines || {}).forEach((fleetId) => {
        if (polylines[fleetId] && polylines[fleetId][0]) {
          newData[fleetId] = decodePolyline(polylines[fleetId][0], 5);
        }
      });
      return {
        data: {
          ...state.data,
          ...newData,
        },
      };
    }
    default:
      return state;
  }
}
